<template>
    <layout class="recharge-history-wrapper">
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad">
            <ul class="history-list">
                <li class="history-item" v-for="item in list" :key="item.id">
                    <div class="top-row">
                        <span>{{item.memberName}}</span>
                        <div>
                            <img src="../assets/img/record.png" alt="" class="icon-record"><span class="time">{{item.count}}次</span>
                        </div>
                    </div>
                    <div class="desc-row">订单编号：{{item.orderNo}}</div>
                    <div class="desc-row">充值时间：{{item.createdTime}}</div>
                    <div class="desc-row">充值分店：{{item.storeName}}</div>
                </li>
            </ul>
        </van-list>
    </layout>
</template>
<script>
    export default {
        name: "RechargeHistory",
        data() {
            return {
                loading: false,
                finished: false,
                page: {
                    current: 1,
                    size: 10
                },
                list: [],
            }
        },
        methods: {
            onLoad() {
                this.loadRechargePage(this.page.current + 1);
            },

            /**
             * 获取充值列表
             * @param current
             * @returns {Promise<void>}
             */
            async loadRechargePage(current) {
                this.loading = true;
                try {
                    let {data} = await this.$req.getRechargePage({
                        size: this.page.size,
                        current: current
                    });
                    data.records.forEach(item => {
                        this.list.push(item);
                    });

                    this.page.current = data.current;
                    if (this.list.length >= data.total) {
                        this.finished = true;
                    }
                } catch (e) {
                    //TODO
                } finally {
                    this.loading = false;
                }
            }
        },
        mounted() {
            this.loadRechargePage(this.page.current)
        }
    }
</script>